import React from 'react'
import Footer from '../Footer'
import Breadcrumbs from '../Breadcrumbs'
import '../../css/infoDocumentacion.scss'

import aforo from '../../assets/images/documentacion/aforo.png'
import bascula from '../../assets/images/documentacion/bascula.png'
import motocicleta from '../../assets/images/icons/motocicleta-blanco.png'



import { Link } from "react-router-dom";

export default function ViajarConAuto() {

    return (
        <>
            <section className='info-documentacion'>

                {/* HERO */}
                <div className='documentacion-hero'>
                    <div className='overlay'></div>

                    <div className='container hero-content'>
                        <div style={{ marginTop: '4rem' }}>
                            <Breadcrumbs />
                        </div>

                        <h1>Documentación para viajar con vehículo</h1>

                        <p>
                            Prepárate para tu travesía. Conoce los requisitos y documentos
                            necesarios para el embarque de vehículos desde 2 hasta 13 metros lineales.
                        </p>
                    </div>
                </div>

                <div className='container documentacion-content'>

                    {/* DOCUMENTOS */}
                    <section className='documentacion-grid'>

                        <div className='card'>
                                                   
                            <h2 className='title-icon'>
                                <i className="fi fi-rs-document-signed"></i>
                                <span>Documentos básicos obligatorios</span>
                            </h2>

                            <ul className='documentos-list'>
                                <li><i className="fi fi-rs-id-card"></i><span>Identificación oficial vigente</span></li>
                                <li><i className="fi fi-rs-credit-card-buyer"></i><span>Licencia de conducir vigente</span></li>
                                <li><i class="fi fi-rr-car"></i><span>Tarjeta de circulación</span></li>
                                <li><i className="fi fi-rs-file-invoice"></i><span>Factura o copia de la misma</span></li>
                                <li><i class="fi fi-rs-contract"></i><span>Póliza de seguro contra daños a terceros</span></li>
                            </ul>
                        </div>

                        <div className='moto-card'>
                            <img src={motocicleta} alt='Ícono motocicleta' />
                            <h3>Seguridad para motocicletas</h3>
                            <p>
                                Por tu seguridad y la de tu vehículo,
                                <strong> traje contigo 3 cinchos de seguridad</strong> para el trincado a bordo.
                            </p>
                        </div>

                    </section>

                    {/* FRONTERIZO Y CARGA */}
                    <section className='info-columns'>

                        <div className='card'>
                            <h2><i class="fi fi-rs-border-center-h"></i> <span>Viaje en Zona Fronteriza</span></h2>

                            <p>
                                Para vehículos extranjeros o fronterizos se requiere:
                            </p>

                            <ul>
                                <li>Pedimento de importación temporal o definitiva.</li>

                                <li>
                                    Los decretos de algunos vehículos son para uso local,
                                    por lo que puede requerirse regularización y pago de impuestos.
                                </li>
                            </ul>
                        </div>

                        <div className='card'>
                            <h2><i class="fi fi-rs-truck-container"></i> <span>Automóvil de Carga</span></h2>

                            <ul>
                                <li>Complemento Carta Porte V. 3.1</li>
                                <li>Factura comercial de la carga</li>
                                <li>Licencia vigente tipo E</li>
                            </ul>

                            <h3 className='sub-title'>
                                ¿Llevas material peligroso?
                            </h3>

                            <ul>
                                <li>Hoja de seguridad del producto</li>
                                <li>Tarjeta de circulación</li>
                            </ul>
                        </div>

                    </section>

                    {/* REVISION */}
                    <section className='revision-section'>

                        <div className='revision-text'>
                            <h2><i class="fi fi-rs-search"></i> <span>Revisión por Autoridades</span></h2>

                            <p>
                                Cada puerto cuenta con procedimientos y controles independientes
                                realizados por autoridades federales como Aduana, SEMAR y SEDENA.
                            </p>

                            <p>
                                Las autoridades pueden solicitar inspección total del vehículo
                                antes del embarque.
                            </p>
                        </div>

                        <div className='revision-card'>

                            <div className='revision-header'>
                                <div>
                                    <i class="fi fi-rs-scale"></i>
                                </div>
                                <div>
                                    <h3>Aforo y Báscula</h3>
                                    <p>Verificación de dimensiones y peso del vehículo.</p>
                                </div>
                               
                            </div>

                            <div className='tickets-grid'>

                                <div className='ticket-item'>
                                    <img src={bascula} alt='Ticket báscula' />

                                    <span>Ticket Báscula</span>

                                    <p>
                                        Documento emitido por el recinto portuario.
                                    </p>
                                </div>

                                <div className='ticket-item'>
                                    <img src={aforo} alt='Ticket aforo' />

                                    <span>Aforo</span>

                                    <p>
                                        Incluye medidas, placas y contenido declarado. Emitido por Baja Ferries.
                                    </p>
                                </div>

                            </div>

                        </div>

                    </section>

                    {/* TIEMPOS */}
                    <section className='tiempos-section'>
                        <div className='tiempo-card'>
                            <h2><i class="fi fi-rs-clock-five"></i> <span>Tiempo de espera</span></h2>
                            <div className='tiempo-item'>
                                <span>Turistas</span>
                                <strong>2 hrs</strong>
                            </div>

                            <div className='tiempo-item'>
                                <span>Carga</span>
                                <strong>3 hrs</strong>
                            </div>

                        </div>

                        <div className='notas-card'>

                            <h2>Notas importantes</h2>

                            <ul>
                                <li>
                                    Todo acompañante debe esperar fuera del vehículo
                                    durante la revisión.
                                </li>

                                <li>
                                    Se aplican cargos portuarios adicionales.
                                </li>

                                <li>
                                    Línea blanca o electrónicos nuevos deben presentar factura.
                                </li>

                                <li>
                                    Vehículos sin documentación completa pueden ser retenidos.
                                </li>

                                <li>
                                    Material peligroso requiere autorización del capitán.
                                </li>
                            </ul>

                            <div className='temas-relacionados'>

                                <h3>Temas relacionados</h3>

                                <div className='tags'>

                                    <Link to='/viajas-con-moto'>
                                        ¿Viajas con moto?
                                    </Link>

                                    <Link to='/viajar-con-menores-de-edad'>
                                        Viajar con menores
                                    </Link>

                                    <Link to='/viajar-con-mascotas'>
                                        Viajar con mascotas
                                    </Link>

                                </div>

                            </div>

                        </div>

                    </section>

                </div>

                <Footer />
            </section>
        </>
    )
}